module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens15-a2e3d14e9c4cd854737bc80255997a4a.jpg";